import { render, staticRenderFns } from "./WarehouseUnitsPage.vue?vue&type=template&id=da59919e&scoped=true&"
import script from "./WarehouseUnitsPage.vue?vue&type=script&lang=js&"
export * from "./WarehouseUnitsPage.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseUnitsPage.vue?vue&type=style&index=0&id=da59919e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da59919e",
  null
  
)

export default component.exports